import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import styled from 'styled-components';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useTranslation } from '@yoweb/next-i18next';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { completeTask } from '@poplar/lib/api/tasks';
import { ApiResponseStatus } from '@poplar/lib/api/utils';
import { ActionModalHeader } from '@poplar/components/ActionModal';
import { SkippedConfirmationStep } from './SkippedConfirmationStep';
import { NeedsWorkConfirmationStep } from './NeedsWorkConfirmationStep';
import { AdditionalFeedbackStep } from './AdditionalFeedbackStep';
import { ConfirmationStep } from './ConfirmationStep';
import { NeedsWorkStep } from './NeedsWorkStep';
import { OverallStep } from './OverallStep';
import { Flyout } from '@poplar/components/Flyout';
import { FlyoutBack } from '@poplar/components/Flyout/FlyoutBack';
import { FlyoutClose } from '@poplar/components/Flyout/FlyoutClose';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Step;

(function (Step) {
  Step[Step["OVERALL_FEEDBACK"] = 0] = "OVERALL_FEEDBACK";
  Step[Step["ADDITIONAL_FEEDBACK"] = 1] = "ADDITIONAL_FEEDBACK";
  Step[Step["STILL_NEED_HELP"] = 2] = "STILL_NEED_HELP";
  Step[Step["CONFIRMATION"] = 3] = "CONFIRMATION";
  Step[Step["CONFIRMATION_SKIP_FEEDBACK"] = 4] = "CONFIRMATION_SKIP_FEEDBACK";
  Step[Step["CONFIRMATION_STILL_NEED_HELP"] = 5] = "CONFIRMATION_STILL_NEED_HELP";
})(Step || (Step = {}));

var getInitialValues = function getInitialValues() {
  var initialRating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    detailFeedbackText: '',
    generalFeedbackV2: {
      starRating: initialRating,
      specificFeedbackList: []
    },
    feedbackSkipped: false,
    proposalFeedbackList: [],
    proposalFeedbackSkipped: false
  };
};

var stepIndicator = function stepIndicator(step, t) {
  var displayOrder = [Step.OVERALL_FEEDBACK, Step.ADDITIONAL_FEEDBACK];
  var index = displayOrder.indexOf(step);

  if (index !== -1) {
    return t('page-stepper-info', {
      current: index + 1,
      total: displayOrder.length,
      ns: 'common'
    });
  }
};

var FeedbackStepRenderer = function FeedbackStepRenderer(_ref) {
  var step = _ref.step,
      taskFeedback = _ref.taskFeedback,
      feedbackCategories = _ref.feedbackCategories,
      isSubmitting = _ref.isSubmitting,
      onSetStep = _ref.onSetStep,
      onSubmit = _ref.onSubmit,
      onResetState = _ref.onResetState,
      onClose = _ref.onClose;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [step === Step.OVERALL_FEEDBACK && /*#__PURE__*/_jsx(OverallStep, {
      taskFeedback: taskFeedback,
      feedbackCategories: feedbackCategories,
      isSubmitting: isSubmitting,
      onHelpStillNeeded: function onHelpStillNeeded() {
        return onSetStep(Step.STILL_NEED_HELP);
      },
      onSkipFeedback: onSubmit,
      onNext: function onNext() {
        return onSetStep(Step.ADDITIONAL_FEEDBACK);
      }
    }), step === Step.STILL_NEED_HELP && /*#__PURE__*/_jsx(NeedsWorkStep, {
      taskFeedback: taskFeedback,
      onSubmitted: function onSubmitted() {
        onSetStep(Step.CONFIRMATION_STILL_NEED_HELP);
        onResetState();
      }
    }), step === Step.ADDITIONAL_FEEDBACK && /*#__PURE__*/_jsx(AdditionalFeedbackStep, {
      taskFeedback: taskFeedback,
      isSubmitting: isSubmitting,
      onNext: onSubmit
    }), step === Step.CONFIRMATION && /*#__PURE__*/_jsx(ConfirmationStep, {
      taskFeedback: taskFeedback,
      onClose: onClose
    }), step === Step.CONFIRMATION_SKIP_FEEDBACK && /*#__PURE__*/_jsx(SkippedConfirmationStep, {
      taskFeedback: taskFeedback,
      onClose: onClose
    }), step === Step.CONFIRMATION_STILL_NEED_HELP && /*#__PURE__*/_jsx(NeedsWorkConfirmationStep, {})]
  });
};

export var FeedbackFlyout = function FeedbackFlyout(_ref2) {
  var isOpen = _ref2.isOpen,
      taskFeedback = _ref2.taskFeedback,
      feedbackCategories = _ref2.feedbackCategories,
      initialRating = _ref2.initialRating,
      onClose = _ref2.onClose,
      onSubmitted = _ref2.onSubmitted;

  var _useToast = useToast(),
      showToastError = _useToast.showToastError;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useState = useState(Step.OVERALL_FEEDBACK),
      step = _useState[0],
      setStep = _useState[1];

  useEffect(function () {
    if (isOpen) {
      setStep(Step.OVERALL_FEEDBACK);
    }
  }, [isOpen]);

  if (!taskFeedback) {
    return null;
  }

  var handleFeedbackSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formPayload, _ref3) {
      var setSubmitting, resetForm, response, _formPayload$generalF, _formPayload$generalF2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref3.setSubmitting, resetForm = _ref3.resetForm;
              _context.next = 3;
              return completeTask(taskFeedback.taskId, {
                taskFeedback: formPayload
              });

            case 3:
              response = _context.sent;

              if (response.status === ApiResponseStatus.ERROR) {
                showToastError();
              } else {
                if (formPayload.feedbackSkipped && !((_formPayload$generalF = formPayload.generalFeedbackV2) !== null && _formPayload$generalF !== void 0 && (_formPayload$generalF2 = _formPayload$generalF.starRating) !== null && _formPayload$generalF2 !== void 0 && _formPayload$generalF2.valueOf())) {
                  setStep(Step.CONFIRMATION_SKIP_FEEDBACK);
                } else {
                  setStep(Step.CONFIRMATION);
                }

                setSubmitting(false);
                resetForm({
                  values: getInitialValues()
                });
                onSubmitted === null || onSubmitted === void 0 ? void 0 : onSubmitted();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFeedbackSubmit(_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var title = stepIndicator(step, t);
  var initialValues = getInitialValues(initialRating);

  var handleBack = function handleBack() {
    switch (step) {
      case Step.STILL_NEED_HELP:
      case Step.ADDITIONAL_FEEDBACK:
        setStep(Step.OVERALL_FEEDBACK);
        break;

      default:
        break;
    }
  };

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: initialValues,
    onSubmit: handleFeedbackSubmit,
    enableReinitialize: true,
    children: function children(_ref5) {
      var handleSubmit = _ref5.handleSubmit,
          resetForm = _ref5.resetForm,
          isSubmitting = _ref5.isSubmitting,
          dirty = _ref5.dirty;

      var resetState = function resetState() {
        return resetForm({
          values: getInitialValues(initialRating)
        });
      };

      var handleDirtyOnClose = function handleDirtyOnClose() {
        if (dirty) {
          var result = confirm(t('todo-feedback.exit-warning'));

          if (!result) {
            return;
          }
        }

        onClose();
        resetState();
      };

      var shouldShowBackButton = [Step.STILL_NEED_HELP, Step.ADDITIONAL_FEEDBACK].includes(step);
      return /*#__PURE__*/_jsxs(Flyout, {
        "data-testid": "task-feedback-flyout",
        isOpen: isOpen,
        onClose: handleDirtyOnClose,
        children: [/*#__PURE__*/_jsx(FlyoutClose, {
          size: "sm",
          onClose: onClose,
          "data-testid": "flyout-close-button"
        }), shouldShowBackButton && /*#__PURE__*/_jsx(FlyoutBack, {
          onClick: handleBack,
          "data-testid": "flyout-back-button"
        }), /*#__PURE__*/_jsxs(GridForm, {
          children: [/*#__PURE__*/_jsx(ActionModalHeader, {
            title: title,
            textAlign: "center",
            borderless: true
          }), /*#__PURE__*/_jsx(FeedbackStepRenderer, {
            taskFeedback: taskFeedback,
            step: step,
            isSubmitting: isSubmitting,
            feedbackCategories: feedbackCategories,
            onSetStep: setStep,
            onSubmit: handleSubmit,
            onResetState: resetState,
            onBack: handleBack,
            onClose: onClose
          })]
        })]
      });
    }
  });
};
var GridForm = styled(Form).withConfig({
  componentId: "sc-7o9kxl-0"
})(["&&{display:grid;height:100%;grid-template-rows:min-content auto;}"]);